import React from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import bubbleWelcomeImage from '../../../assets/images/bubbleWelcomeProfile.png';
import {Image} from '../../common/image';
import {
  CarouselSlideContent,
  CarouselSlideContentLeft,
  CarouselSlideContentProps,
  CarouselSlideDefinition,
  CarouselSlideTitle,
} from '../carouselCommon';
import {WelcomeCarouselPersonaFormContainer} from './forms/welcomeCarouselPersonaFormContainer';

/*
 * Style.
 */

const WelcomeImage = styled.div`
  display: grid;
  grid-row: mid-left / span left-footer;
  margin-left: 90px;
  margin-top: 95px;
`;

/*
 * Helpers.
 */

function renderContent(props: CarouselSlideContentProps) {
  const {index, onPreviousClick, onNextClick} = props;

  return (
    <CarouselSlideContent key={index}>
      <CarouselSlideContentLeft>
        <CarouselSlideTitle>
          <Trans id="welcomecarousel-persona-title">Let&apos;s set up your profile</Trans>
        </CarouselSlideTitle>
      </CarouselSlideContentLeft>
      <WelcomeCarouselPersonaFormContainer onPreviousClick={onPreviousClick} onCompleteForm={onNextClick} />
      <WelcomeImage>
        <Image src={bubbleWelcomeImage} width={414} height={250} />
      </WelcomeImage>
    </CarouselSlideContent>
  );
}

/*
 * Slide defintion.
 */

export const welcomeCarouselPersonaSlide: CarouselSlideDefinition = {
  renderContent,
};
